import { useSnackbar } from "notistack";

const useSnackbarMAS = () => {
  const { enqueueSnackbar } = useSnackbar();

  const snackbar = ({ message, variant, durationInMs = 2000 }) => {
    return enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      autoHideDuration: durationInMs,
    });
  };

  const snackbarError = ({
    message,
    variant = "error",
    durationInMs = 2000,
  }) => {
    return enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      autoHideDuration: durationInMs,
    });
  };

  const snackbarSuccess = ({
    message,
    variant = "success",
    durationInMs = 2000,
  }) => {
    return enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      autoHideDuration: durationInMs,
    });
  };

  return { snackbar, snackbarError, snackbarSuccess };
};

export default useSnackbarMAS;
